import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
// import 'vuetify/src/stylus/app.styl'

// Vue.use(Vuetify, {
//   iconfont: 'md',
// })
// import Vue from 'vue'
// import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

const opts = {}

export default new Vuetify(opts)
